class CartSummaryPoints extends HTMLElement {
  static get observedAttributes() {
    return ['data-points-earned'];
  }

  constructor() {
    super();

    this.isEnrolled = false;
    this.pointsEarned = 0;

    this.handleRewardsUpdated = this.handleRewardsUpdated.bind(this);
    this.handleRewardsInitialized = this.handleRewardsInitialized.bind(this);
  }

  connectedCallback() {
    this.initialize();
  }

  disconnectedCallback() {
    document.removeEventListener('aspen:rewards:updated', this.handleRewardsUpdated);
    document.removeEventListener('aspen:rewards:initialized', this.handleRewardsInitialized);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) {
      return;
    }

    if (name === 'data-points-earned') {
      this.pointsEarned = parseFloat(newValue) || 0;

      if (this.isConnected) {
        this.render();
      }
    }
  }

  initialize() {
    this.isEnrolled = this.querySelector('.content-points-summary') !== null;

    if (!this.isEnrolled) {
      this.style.display = 'none';
    }

    const pointsAttr = this.getAttribute('data-points-earned');

    if (pointsAttr) {
      this.pointsEarned = parseFloat(pointsAttr) || 0;
    }

    document.addEventListener('aspen:rewards:updated', this.handleRewardsUpdated);
    document.addEventListener('aspen:rewards:initialized', this.handleRewardsInitialized);

    if (window.AspenRewards) {
      const state = window.AspenRewards.getState();
      this.updateFromState(state);
    } else {
      const checkAspenRewards = () => {
        if (window.AspenRewards) {
          const state = window.AspenRewards.getState();
          this.updateFromState(state);
        } else {
          setTimeout(checkAspenRewards, 50);
        }
      };

      checkAspenRewards();
    }
  }

  updateFromState(state) {
    if (state.isEnrolled === this.isEnrolled) {
      return;
    }

    this.isEnrolled = state.isEnrolled;
    this.render();
  }

  handleRewardsInitialized(event) {
    this.updateFromState(event.detail);
  }

  handleRewardsUpdated(event) {
    this.updateFromState(event.detail);
  }

  formatNumber(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  render() {
    if (!this.isEnrolled) {
      this.innerHTML = '';
      this.style.display = 'none';

      return;
    }

    this.innerHTML = `
      <div class='content-points-summary'>
        <p>Points Earned with Purchase:</p>
        <p>${this.formatNumber(this.pointsEarned)}</p>
      </div>
    `;

    this.style.display = '';
  }
}

if (!customElements.get('cart-summary-points')) {
  customElements.define('cart-summary-points', CartSummaryPoints);
}
